module.exports = "\n<div class=\"card card-login\">\n  <div class=\"card-header text-center\" data-background-color=\"red\">\n    <h4 class=\"card-title\">Введите новый пароль</h4>\n  </div>\n  <div class=\"alert alert-primary error-info text-center\" [hidden]=\"!_resetPasswordError\">\n    {{_resetPasswordError}}\n  </div>\n  <new-password-form #newPassword (onSubitPasswordClick)=\"resetPassword($event)\"></new-password-form>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/account/resetPassword/resetPassword.component.html
// module id = ../../../../../src/app/account/resetPassword/resetPassword.component.html
// module chunks = 0